/**
 * Yes/No field codec — normalizes the driver's string UI value (`'1'`/`'0'`) to
 * the integer `1`/`0` on save, so the persisted value matches the numeric data
 * contract. Opt-in per field via `numeric: true` (the factory auto-injects this
 * only for those fields, never globally — many entities intentionally store
 * `'1'`/`'0'` strings and must not be silently re-typed).
 *
 * @module
 */

/**
 * Creates a FieldCodec for `numeric: true` yes/no fields.
 *
 * `serialize` always returns `0` for the "no" case — NOT `undefined` — because a
 * codec returning `undefined` makes the editor omit the key, and on a full-replace
 * PUT an omitted key is dropped from the row (a stale-field bug). `parse` is
 * identity: the yesno driver's `setValue` already normalizes `'1' | 1 | true`.
 *
 * @returns {import('../../contracts/forms.js').FieldCodec}
 */
export function createYesnoCodec() {
  return {
    /** @param {unknown} wireValue */
    parse(wireValue) {
      return wireValue;
    },

    /** @param {unknown} uiValue */
    serialize(uiValue) {
      return (uiValue === '1' || uiValue === 1 || uiValue === true) ? 1 : 0;
    },
  };
}
